import React, { useEffect, useState } from 'react'
import Loader from '../Components/Global/Loader';
import { useAuth } from '../Context/AuthContext';

const useAuthentication = (allowedRoles) => {
    const [allowLoading, setallowLoading]=useState(true)
    const {
        userRole,
        Logout,
    } = useAuth();
    
    
    
    useEffect(() => {
        if (userRole !== undefined) {
            setallowLoading(false)

            if (!allowedRoles.includes(userRole)) {
                setallowLoading(false)

                Logout();
            }
        }

    }, [userRole])
    return { allowLoading }
}

export default useAuthentication